// GENERATED FILE. Shared by the designer and estimate documents. Do not edit by hand.
//
// MCS MGD 003 "Determining the Electrical Self-Consumption of Domestic Solar
// Photovoltaic (PV) Installations with and without Electrical Energy Storage",
// Issue 2.0 (1 April 2022), section 7 lookup tables. Source PDF
// mcscertified.com/wp-content/uploads/2025/02/MGD-003-Solar-PV-Self-Consumption-Issue-2.0-Final.pdf,
// sha256 937de56ad97cb50c65a253b5fb534d9b0a9af15f60595a0fbe60274416c98b0a. Regenerate with payaca-agents/ops/mcs-irradiance/generate_mgd003_tables.py.
//
// Per occupancy archetype and annual-consumption band (1,500..5,999 kWh in
// 500 kWh steps), a grid of self-consumption percentages: rows are annual
// generation bands (0..5,999 kWh in 300 kWh steps), columns are PV only then
// battery usable capacity bands (>=1.1 <2.1 … >=14.1 <15.1 kWh).

export type Mgd003Archetype =
  | 'HOME_ALL_DAY'
  | 'IN_HALF_THE_DAY'
  | 'OUT_DURING_THE_DAY';
export const MGD003_CONSUMPTION_BANDS_KWH = [
  1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500,
] as const;
export const MGD003_GENERATION_STEP_KWH = 300;
export const MGD003_GENERATION_MAX_KWH = 6000;
export const MGD003_BATTERY_COLUMN_MIN_KWH = 1.1;
export const MGD003_BATTERY_COLUMNS = 14;

export const MGD003_TABLES: Record<
  Mgd003Archetype,
  Record<number, number[][]>
> = {
  HOME_ALL_DAY: {
    1500: [
      [70, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [52, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [46, 76, 88, 93, 94, 94, 94, 94, 94, 95, 95, 95, 95, 95, 95],
      [38, 67, 80, 85, 88, 89, 89, 89, 89, 89, 89, 89, 89, 89, 89],
      [33, 60, 72, 78, 81, 83, 83, 83, 83, 83, 83, 83, 84, 84, 84],
      [29, 53, 65, 71, 74, 76, 76, 76, 76, 76, 76, 77, 77, 78, 78],
      [26, 48, 58, 64, 67, 69, 69, 69, 69, 70, 70, 70, 70, 71, 71],
      [23, 43, 53, 58, 61, 62, 63, 63, 63, 63, 63, 64, 64, 64, 65],
      [21, 39, 49, 53, 56, 57, 57, 58, 58, 58, 58, 58, 58, 58, 58],
      [20, 36, 45, 49, 51, 52, 52, 52, 52, 52, 52, 52, 52, 52, 52],
      [18, 33, 41, 46, 47, 47, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [17, 31, 38, 42, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43],
      [16, 29, 35, 39, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
      [15, 27, 33, 37, 37, 37, 37, 37, 37, 37, 37, 37, 37, 37, 37],
      [15, 25, 31, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
      [14, 24, 29, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
      [13, 23, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      [13, 21, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
      [12, 20, 25, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27],
      [12, 20, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25],
    ],
    2000: [
      [77, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [58, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [50, 76, 88, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [43, 70, 82, 88, 91, 92, 93, 93, 93, 93, 93, 93, 93, 93, 93],
      [38, 64, 76, 83, 87, 88, 89, 89, 89, 89, 90, 90, 90, 90, 90],
      [34, 58, 70, 77, 81, 83, 84, 84, 84, 85, 85, 85, 86, 86, 86],
      [30, 53, 64, 71, 75, 77, 78, 78, 79, 79, 79, 80, 80, 80, 80],
      [28, 48, 59, 66, 69, 71, 72, 72, 73, 73, 73, 73, 74, 74, 74],
      [25, 44, 54, 60, 64, 66, 67, 67, 68, 68, 68, 68, 68, 68, 68],
      [24, 41, 50, 56, 59, 61, 62, 63, 63, 63, 63, 63, 63, 63, 63],
      [22, 38, 46, 52, 55, 57, 58, 59, 59, 59, 59, 59, 59, 59, 59],
      [21, 35, 43, 49, 52, 53, 54, 55, 55, 55, 55, 55, 55, 55, 55],
      [20, 33, 40, 45, 49, 50, 51, 51, 51, 51, 51, 51, 51, 51, 51],
      [18, 31, 38, 42, 45, 47, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [18, 29, 35, 40, 43, 44, 44, 44, 44, 44, 44, 44, 44, 44, 44],
      [17, 27, 33, 38, 41, 41, 41, 41, 41, 41, 41, 41, 41, 41, 41],
      [16, 26, 32, 36, 39, 39, 39, 39, 39, 39, 39, 39, 39, 39, 39],
      [15, 25, 31, 34, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36],
      [15, 24, 30, 33, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
      [14, 23, 29, 32, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33],
    ],
    2500: [
      [86, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [65, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [56, 82, 92, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [48, 75, 86, 91, 93, 94, 94, 94, 95, 95, 95, 95, 95, 95, 95],
      [43, 68, 81, 87, 90, 92, 92, 93, 93, 93, 93, 93, 93, 93, 93],
      [38, 62, 75, 82, 86, 88, 89, 90, 90, 90, 90, 90, 90, 90, 91],
      [34, 57, 69, 76, 81, 83, 85, 86, 86, 86, 86, 86, 87, 87, 87],
      [32, 52, 63, 71, 75, 78, 80, 81, 81, 81, 82, 82, 82, 82, 82],
      [29, 48, 59, 65, 70, 73, 74, 75, 76, 76, 77, 77, 77, 77, 77],
      [27, 45, 55, 61, 65, 68, 69, 70, 71, 71, 71, 71, 72, 72, 72],
      [25, 42, 51, 57, 61, 64, 65, 66, 67, 67, 67, 67, 67, 67, 67],
      [24, 39, 48, 54, 58, 60, 61, 62, 63, 63, 63, 63, 63, 63, 63],
      [23, 37, 45, 50, 54, 57, 58, 59, 60, 60, 60, 60, 60, 60, 60],
      [22, 35, 42, 47, 51, 53, 55, 56, 56, 57, 57, 57, 57, 57, 57],
      [21, 33, 40, 45, 48, 51, 52, 53, 53, 54, 54, 54, 54, 54, 54],
      [20, 31, 38, 43, 46, 48, 49, 50, 50, 50, 50, 50, 50, 50, 50],
      [19, 30, 36, 41, 44, 46, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [18, 29, 35, 39, 42, 44, 45, 45, 45, 45, 45, 45, 45, 45, 45],
      [17, 27, 33, 37, 40, 42, 42, 42, 42, 42, 42, 42, 42, 42, 42],
      [17, 26, 31, 35, 38, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
    ],
    3000: [
      [95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [72, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [62, 86, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [54, 79, 89, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [48, 73, 85, 90, 92, 93, 94, 94, 94, 94, 94, 95, 95, 95, 95],
      [43, 68, 79, 86, 89, 91, 92, 92, 93, 93, 93, 93, 93, 93, 93],
      [39, 63, 74, 81, 85, 87, 88, 89, 90, 91, 91, 91, 91, 91, 91],
      [36, 58, 69, 76, 80, 83, 85, 86, 86, 87, 88, 88, 88, 88, 88],
      [34, 54, 64, 71, 76, 79, 81, 82, 82, 83, 83, 84, 84, 84, 84],
      [32, 50, 60, 67, 71, 74, 76, 77, 78, 78, 79, 79, 79, 79, 79],
      [30, 47, 56, 63, 67, 71, 72, 73, 74, 74, 75, 75, 75, 75, 75],
      [28, 44, 52, 59, 64, 67, 68, 69, 70, 70, 71, 71, 71, 71, 71],
      [26, 41, 49, 55, 60, 63, 64, 65, 66, 66, 67, 67, 67, 67, 67],
      [25, 38, 46, 52, 56, 59, 61, 62, 63, 63, 64, 64, 64, 64, 64],
      [24, 36, 44, 49, 54, 56, 58, 59, 60, 60, 61, 61, 61, 61, 61],
      [23, 35, 42, 47, 51, 54, 56, 57, 58, 58, 58, 58, 58, 58, 58],
      [22, 33, 40, 45, 49, 52, 54, 55, 55, 55, 56, 56, 56, 56, 56],
      [21, 31, 38, 43, 47, 50, 52, 53, 53, 53, 53, 53, 53, 53, 53],
      [21, 30, 36, 41, 45, 48, 50, 50, 50, 50, 50, 50, 50, 50, 50],
      [20, 30, 35, 40, 43, 46, 47, 47, 47, 47, 47, 47, 47, 47, 47],
    ],
    3500: [
      [95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [77, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [67, 87, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [59, 82, 91, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [53, 77, 87, 92, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [48, 72, 83, 88, 91, 93, 94, 94, 94, 94, 95, 95, 95, 95, 95],
      [44, 67, 78, 84, 88, 91, 92, 93, 93, 93, 93, 93, 94, 94, 94],
      [41, 62, 73, 80, 84, 87, 89, 90, 91, 91, 91, 91, 91, 92, 92],
      [38, 58, 69, 76, 80, 84, 86, 87, 88, 88, 88, 88, 88, 89, 89],
      [36, 55, 65, 71, 76, 80, 82, 83, 84, 84, 84, 85, 85, 85, 85],
      [34, 51, 61, 68, 73, 76, 78, 79, 80, 80, 80, 81, 81, 82, 82],
      [32, 48, 57, 64, 69, 72, 74, 76, 76, 76, 77, 77, 78, 78, 78],
      [30, 45, 54, 61, 65, 69, 71, 72, 73, 73, 73, 73, 74, 74, 74],
      [29, 43, 51, 57, 62, 66, 68, 69, 70, 70, 70, 70, 70, 70, 71],
      [28, 40, 48, 54, 59, 63, 65, 66, 66, 67, 67, 67, 67, 67, 68],
      [27, 39, 46, 52, 56, 60, 62, 63, 63, 64, 64, 64, 64, 64, 65],
      [25, 37, 44, 50, 54, 57, 59, 60, 61, 61, 61, 62, 62, 62, 62],
      [25, 36, 42, 47, 52, 55, 57, 58, 59, 59, 59, 60, 60, 60, 60],
      [24, 35, 41, 46, 50, 53, 55, 56, 57, 57, 57, 57, 57, 57, 57],
      [23, 34, 39, 44, 48, 51, 53, 54, 54, 54, 54, 54, 54, 54, 54],
    ],
    4000: [
      [95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [82, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [71, 89, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [63, 84, 92, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [57, 80, 89, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [52, 75, 86, 91, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [48, 71, 82, 87, 91, 92, 93, 94, 94, 94, 95, 95, 95, 95, 95],
      [45, 66, 78, 84, 88, 90, 91, 92, 93, 93, 93, 93, 93, 94, 94],
      [42, 63, 73, 80, 85, 87, 89, 90, 91, 91, 92, 92, 92, 92, 92],
      [40, 59, 69, 76, 81, 84, 86, 87, 88, 88, 89, 89, 90, 90, 90],
      [37, 55, 65, 72, 76, 80, 82, 83, 84, 85, 86, 86, 87, 87, 87],
      [35, 52, 61, 68, 72, 76, 78, 80, 80, 81, 82, 83, 83, 84, 84],
      [34, 49, 58, 64, 69, 72, 75, 76, 77, 78, 78, 79, 80, 80, 80],
      [32, 47, 55, 61, 66, 69, 72, 73, 74, 75, 75, 75, 76, 76, 77],
      [31, 44, 52, 58, 63, 67, 69, 70, 71, 72, 72, 72, 73, 73, 73],
      [30, 43, 50, 56, 60, 64, 66, 68, 69, 69, 70, 70, 70, 70, 71],
      [29, 41, 48, 53, 58, 61, 64, 65, 66, 67, 67, 67, 68, 68, 68],
      [28, 40, 46, 51, 56, 59, 62, 63, 64, 65, 65, 65, 65, 66, 66],
      [27, 38, 45, 50, 54, 58, 60, 61, 62, 63, 63, 63, 63, 63, 63],
      [26, 37, 43, 48, 53, 56, 59, 60, 61, 61, 62, 62, 62, 62, 62],
    ],
    4500: [
      [95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [87, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [75, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [67, 87, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [61, 83, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [56, 78, 88, 92, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [52, 74, 84, 89, 92, 94, 94, 95, 95, 95, 95, 95, 95, 95, 95],
      [49, 70, 80, 86, 90, 92, 93, 94, 94, 94, 95, 95, 95, 95, 95],
      [46, 66, 76, 82, 87, 90, 91, 92, 93, 93, 93, 93, 93, 94, 94],
      [43, 62, 72, 79, 83, 87, 89, 90, 91, 92, 92, 92, 92, 92, 92],
      [41, 59, 69, 75, 80, 83, 86, 87, 88, 89, 89, 89, 89, 89, 90],
      [39, 56, 65, 71, 76, 80, 82, 84, 85, 86, 86, 86, 87, 87, 88],
      [37, 53, 62, 68, 73, 76, 79, 81, 82, 82, 83, 83, 84, 84, 84],
      [35, 50, 59, 65, 69, 73, 75, 77, 78, 79, 80, 80, 81, 81, 81],
      [34, 48, 56, 62, 66, 70, 72, 74, 75, 76, 77, 77, 78, 78, 78],
      [33, 46, 54, 59, 64, 67, 70, 72, 73, 74, 74, 75, 75, 75, 75],
      [32, 44, 52, 57, 62, 65, 68, 70, 71, 72, 72, 73, 73, 73, 73],
      [31, 43, 50, 55, 60, 63, 66, 67, 69, 70, 70, 70, 71, 71, 71],
      [30, 41, 47, 53, 58, 61, 64, 65, 67, 67, 68, 68, 68, 68, 69],
      [28, 39, 45, 50, 55, 59, 62, 64, 64, 65, 65, 66, 66, 66, 67],
    ],
    5000: [
      [95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [90, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [77, 92, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [70, 88, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [64, 84, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [60, 81, 90, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [55, 77, 87, 91, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [52, 73, 83, 88, 91, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95],
      [49, 69, 79, 85, 88, 91, 93, 94, 94, 95, 95, 95, 95, 95, 95],
      [47, 66, 75, 81, 86, 89, 91, 92, 93, 93, 94, 94, 94, 94, 94],
      [44, 62, 71, 78, 82, 86, 88, 90, 91, 91, 92, 92, 92, 92, 93],
      [42, 59, 68, 75, 79, 83, 85, 87, 88, 89, 89, 90, 90, 90, 91],
      [40, 56, 65, 71, 76, 80, 82, 84, 85, 86, 87, 87, 88, 88, 88],
      [39, 54, 62, 68, 73, 77, 80, 81, 82, 83, 84, 85, 85, 85, 86],
      [37, 51, 59, 65, 70, 74, 77, 78, 80, 81, 82, 82, 82, 83, 83],
      [36, 49, 57, 63, 67, 71, 74, 76, 77, 78, 79, 79, 79, 80, 80],
      [35, 48, 55, 61, 65, 69, 72, 74, 75, 76, 76, 77, 77, 77, 78],
      [34, 46, 53, 59, 63, 67, 69, 71, 72, 73, 74, 74, 75, 75, 76],
      [33, 44, 51, 57, 61, 65, 67, 69, 70, 71, 72, 72, 73, 73, 74],
      [32, 43, 49, 54, 59, 62, 65, 67, 69, 69, 70, 70, 71, 71, 72],
    ],
    5500: [
      [95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [92, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [79, 92, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [72, 89, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [67, 86, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [62, 83, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [58, 79, 89, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [55, 76, 85, 90, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [52, 72, 82, 87, 91, 93, 94, 94, 95, 95, 95, 95, 95, 95, 95],
      [49, 68, 78, 84, 88, 90, 92, 93, 94, 94, 94, 94, 94, 95, 95],
      [47, 65, 75, 81, 85, 88, 90, 91, 92, 93, 93, 93, 93, 94, 94],
      [45, 62, 72, 78, 82, 85, 88, 89, 91, 91, 91, 91, 92, 92, 93],
      [43, 59, 68, 74, 79, 82, 85, 87, 88, 89, 90, 90, 90, 91, 91],
      [41, 57, 65, 71, 76, 80, 83, 85, 86, 87, 88, 88, 88, 88, 89],
      [40, 54, 62, 68, 73, 77, 80, 82, 84, 85, 86, 86, 86, 86, 86],
      [39, 52, 60, 66, 70, 74, 77, 79, 81, 82, 83, 83, 83, 83, 84],
      [38, 51, 58, 64, 68, 72, 75, 77, 78, 79, 80, 81, 81, 81, 81],
      [37, 49, 57, 62, 66, 70, 73, 75, 76, 77, 78, 79, 79, 79, 79],
      [35, 48, 55, 60, 65, 68, 71, 73, 74, 75, 76, 77, 77, 77, 77],
      [34, 46, 52, 58, 63, 67, 69, 71, 72, 73, 74, 75, 76, 76, 76],
    ],
  },
  IN_HALF_THE_DAY: {
    1500: [
      [62, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [46, 90, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [41, 74, 87, 92, 94, 94, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [34, 63, 77, 83, 86, 87, 88, 88, 88, 88, 88, 88, 88, 89, 89],
      [29, 56, 69, 76, 80, 81, 82, 82, 82, 83, 83, 83, 83, 83, 83],
      [26, 50, 62, 70, 73, 75, 75, 76, 76, 76, 76, 76, 76, 77, 77],
      [23, 45, 56, 63, 67, 68, 69, 69, 69, 70, 70, 70, 70, 70, 71],
      [21, 41, 51, 58, 61, 62, 63, 63, 63, 63, 63, 64, 64, 64, 64],
      [19, 37, 47, 53, 56, 57, 57, 58, 58, 58, 58, 58, 58, 58, 58],
      [17, 34, 43, 48, 51, 52, 52, 52, 52, 52, 52, 52, 52, 52, 52],
      [16, 31, 39, 44, 47, 47, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [15, 28, 36, 40, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43],
      [14, 26, 33, 38, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
      [13, 25, 31, 35, 37, 37, 37, 37, 37, 37, 37, 37, 37, 37, 37],
      [13, 23, 29, 33, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
      [12, 22, 27, 31, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
      [11, 21, 26, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      [11, 20, 25, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
      [11, 19, 24, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27],
      [10, 18, 23, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25],
    ],
    2000: [
      [62, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [46, 90, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [45, 75, 88, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [38, 67, 81, 87, 90, 91, 92, 92, 92, 92, 92, 92, 92, 92, 92],
      [33, 61, 74, 82, 86, 87, 88, 89, 89, 89, 89, 89, 89, 89, 89],
      [29, 54, 67, 75, 80, 82, 83, 84, 84, 84, 84, 85, 85, 85, 85],
      [26, 48, 60, 68, 73, 76, 77, 78, 79, 79, 79, 79, 79, 79, 79],
      [24, 44, 55, 62, 67, 70, 72, 72, 73, 73, 73, 73, 73, 73, 74],
      [22, 40, 50, 57, 62, 65, 66, 67, 68, 68, 68, 68, 68, 68, 68],
      [20, 37, 46, 53, 58, 60, 62, 62, 63, 63, 63, 63, 63, 63, 63],
      [19, 34, 43, 50, 54, 56, 57, 58, 58, 59, 59, 59, 59, 59, 59],
      [17, 32, 40, 46, 50, 52, 53, 54, 55, 55, 55, 55, 55, 55, 55],
      [16, 30, 37, 43, 47, 49, 50, 51, 51, 51, 51, 51, 51, 51, 51],
      [15, 28, 35, 40, 44, 46, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [15, 26, 33, 38, 41, 43, 44, 44, 44, 44, 44, 44, 44, 44, 44],
      [14, 25, 31, 36, 39, 41, 41, 41, 41, 41, 41, 41, 41, 41, 41],
      [13, 23, 29, 34, 37, 39, 39, 39, 39, 39, 39, 39, 39, 39, 39],
      [13, 22, 28, 32, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36],
      [12, 21, 27, 31, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
      [12, 20, 25, 30, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33],
    ],
    2500: [
      [74, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [55, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [48, 78, 90, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [41, 70, 83, 89, 92, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [36, 63, 77, 84, 89, 91, 92, 92, 92, 92, 92, 92, 93, 93, 93],
      [33, 57, 70, 79, 84, 87, 88, 89, 90, 90, 90, 90, 90, 90, 90],
      [29, 52, 64, 73, 79, 82, 84, 85, 86, 86, 86, 86, 87, 87, 87],
      [27, 47, 59, 67, 73, 77, 79, 80, 81, 81, 81, 82, 82, 82, 82],
      [25, 43, 54, 62, 68, 72, 74, 75, 75, 76, 76, 77, 77, 77, 77],
      [23, 39, 50, 58, 63, 67, 69, 70, 71, 71, 71, 71, 72, 72, 72],
      [21, 36, 46, 53, 59, 63, 65, 66, 67, 67, 67, 67, 67, 67, 67],
      [20, 34, 43, 50, 55, 59, 61, 62, 63, 63, 63, 63, 63, 63, 63],
      [19, 32, 40, 47, 52, 55, 57, 58, 59, 59, 60, 60, 60, 60, 60],
      [18, 30, 38, 44, 49, 52, 54, 55, 55, 56, 57, 57, 57, 57, 57],
      [17, 29, 36, 42, 46, 49, 51, 52, 53, 53, 54, 54, 54, 54, 54],
      [16, 27, 34, 39, 44, 47, 49, 50, 50, 50, 50, 50, 50, 50, 50],
      [15, 26, 32, 37, 41, 45, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [15, 24, 30, 35, 39, 42, 45, 45, 45, 45, 45, 45, 45, 45, 45],
      [14, 23, 29, 34, 38, 41, 42, 42, 42, 42, 42, 42, 42, 42, 42],
      [14, 22, 28, 33, 37, 39, 40, 40, 40, 40, 40, 40, 40, 40, 40],
    ],
    3000: [
      [79, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [60, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [53, 81, 91, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [45, 73, 85, 91, 93, 94, 94, 95, 95, 95, 95, 95, 95, 95, 95],
      [40, 67, 80, 87, 90, 92, 93, 93, 94, 94, 94, 94, 94, 94, 94],
      [36, 61, 74, 82, 87, 89, 91, 92, 92, 93, 93, 93, 93, 93, 93],
      [33, 56, 69, 77, 82, 86, 88, 89, 90, 90, 90, 90, 90, 90, 90],
      [30, 51, 63, 72, 77, 81, 84, 85, 86, 87, 87, 87, 87, 87, 87],
      [28, 47, 59, 67, 73, 77, 79, 81, 82, 82, 82, 83, 83, 83, 83],
      [26, 43, 54, 62, 68, 72, 75, 76, 77, 77, 78, 78, 79, 79, 79],
      [24, 40, 51, 58, 64, 68, 70, 72, 73, 73, 74, 74, 74, 75, 75],
      [23, 37, 47, 55, 60, 64, 66, 68, 69, 69, 70, 70, 70, 70, 70],
      [22, 35, 44, 51, 57, 60, 63, 64, 65, 66, 66, 66, 67, 67, 67],
      [21, 33, 42, 48, 53, 57, 60, 61, 62, 62, 63, 63, 63, 64, 64],
      [20, 31, 39, 45, 50, 54, 57, 58, 59, 59, 60, 60, 60, 61, 61],
      [19, 30, 37, 43, 48, 51, 54, 56, 56, 57, 57, 58, 58, 58, 58],
      [18, 28, 35, 41, 46, 49, 52, 53, 54, 55, 55, 55, 56, 56, 56],
      [17, 27, 34, 39, 44, 47, 50, 52, 52, 53, 53, 53, 53, 53, 53],
      [17, 26, 32, 37, 42, 45, 48, 50, 50, 50, 50, 50, 50, 50, 50],
      [16, 25, 31, 36, 40, 44, 46, 47, 47, 47, 47, 47, 47, 47, 47],
    ],
    3500: [
      [84, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [64, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [57, 83, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [48, 76, 87, 92, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [43, 70, 83, 89, 92, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [39, 65, 77, 84, 89, 91, 93, 93, 93, 94, 94, 94, 94, 94, 94],
      [36, 59, 72, 79, 85, 88, 90, 91, 92, 92, 92, 93, 93, 93, 93],
      [33, 55, 66, 74, 80, 85, 87, 89, 89, 90, 90, 91, 91, 91, 91],
      [31, 50, 61, 70, 76, 81, 84, 85, 86, 87, 88, 88, 88, 89, 89],
      [29, 46, 57, 65, 72, 76, 80, 81, 82, 83, 84, 84, 85, 85, 85],
      [27, 43, 53, 61, 67, 72, 75, 77, 78, 79, 80, 80, 81, 81, 81],
      [25, 40, 50, 57, 63, 68, 71, 73, 74, 75, 76, 76, 77, 77, 77],
      [24, 38, 47, 54, 60, 64, 67, 69, 71, 72, 73, 73, 73, 73, 73],
      [23, 36, 44, 51, 57, 61, 64, 66, 68, 69, 70, 70, 70, 70, 70],
      [22, 34, 42, 48, 54, 58, 61, 63, 65, 66, 67, 67, 67, 67, 67],
      [21, 32, 40, 46, 52, 56, 59, 61, 62, 63, 64, 64, 64, 64, 64],
      [20, 31, 38, 44, 49, 53, 56, 58, 60, 61, 61, 62, 62, 62, 62],
      [20, 30, 36, 42, 47, 51, 54, 56, 58, 59, 59, 60, 60, 60, 60],
      [19, 29, 35, 40, 45, 49, 52, 54, 56, 57, 57, 57, 57, 57, 57],
      [18, 28, 34, 39, 43, 47, 50, 53, 54, 54, 54, 54, 54, 54, 54],
    ],
    4000: [
      [89, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [68, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [61, 84, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [52, 77, 88, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [46, 72, 84, 90, 93, 94, 94, 95, 95, 95, 95, 95, 95, 95, 95],
      [41, 67, 79, 86, 90, 92, 93, 94, 94, 94, 94, 94, 94, 94, 94],
      [38, 62, 74, 82, 87, 90, 92, 93, 93, 93, 93, 94, 94, 94, 94],
      [36, 58, 70, 78, 83, 87, 89, 91, 91, 92, 92, 92, 93, 93, 93],
      [33, 54, 65, 73, 79, 84, 87, 88, 89, 90, 90, 91, 91, 91, 91],
      [31, 50, 61, 69, 75, 80, 83, 85, 86, 87, 88, 88, 89, 89, 89],
      [29, 46, 56, 64, 71, 75, 79, 82, 83, 84, 85, 85, 85, 85, 85],
      [28, 43, 53, 60, 67, 71, 75, 78, 80, 81, 81, 82, 82, 82, 82],
      [26, 41, 50, 57, 63, 68, 72, 74, 76, 77, 78, 78, 78, 78, 78],
      [25, 39, 47, 54, 60, 64, 68, 71, 73, 73, 74, 74, 75, 75, 75],
      [24, 37, 45, 51, 57, 62, 65, 68, 69, 70, 71, 71, 72, 72, 72],
      [23, 36, 43, 49, 54, 59, 63, 65, 67, 68, 68, 69, 69, 69, 69],
      [22, 34, 41, 47, 52, 56, 60, 63, 64, 65, 66, 66, 67, 67, 67],
      [22, 32, 39, 44, 50, 54, 58, 60, 62, 63, 64, 64, 65, 65, 65],
      [21, 31, 37, 43, 48, 52, 56, 58, 60, 61, 62, 63, 63, 63, 63],
      [21, 30, 36, 42, 47, 51, 54, 56, 58, 59, 60, 61, 61, 61, 61],
    ],
    4500: [
      [90, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [69, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [62, 85, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [53, 79, 89, 93, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [48, 74, 85, 91, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [44, 69, 81, 88, 91, 93, 94, 94, 94, 95, 95, 95, 95, 95, 95],
      [41, 65, 77, 84, 88, 91, 93, 93, 94, 94, 94, 94, 94, 94, 94],
      [38, 60, 72, 80, 85, 89, 91, 92, 93, 93, 93, 93, 94, 94, 94],
      [36, 56, 67, 75, 81, 85, 88, 90, 91, 92, 92, 92, 93, 93, 93],
      [34, 52, 63, 71, 77, 82, 85, 87, 89, 90, 90, 91, 91, 91, 91],
      [32, 49, 59, 67, 73, 78, 82, 84, 86, 87, 88, 88, 89, 89, 89],
      [30, 46, 56, 63, 70, 74, 78, 81, 83, 84, 85, 86, 86, 87, 87],
      [29, 44, 53, 60, 66, 71, 75, 78, 80, 81, 82, 83, 83, 84, 84],
      [28, 41, 50, 57, 63, 68, 72, 74, 76, 78, 79, 80, 80, 81, 81],
      [26, 40, 48, 54, 60, 65, 69, 71, 73, 75, 76, 76, 77, 78, 78],
      [25, 38, 45, 51, 57, 62, 66, 68, 71, 72, 73, 74, 74, 75, 75],
      [24, 36, 43, 49, 55, 59, 63, 66, 68, 70, 71, 71, 72, 72, 73],
      [24, 34, 41, 47, 52, 57, 61, 64, 66, 68, 69, 69, 69, 70, 71],
      [23, 33, 40, 45, 50, 55, 59, 61, 64, 66, 67, 67, 67, 68, 69],
      [22, 32, 38, 44, 49, 53, 56, 59, 62, 64, 65, 65, 66, 66, 67],
    ],
    5000: [
      [92, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [71, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [62, 85, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [55, 79, 90, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [50, 75, 86, 92, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [46, 70, 82, 89, 92, 94, 94, 95, 95, 95, 95, 95, 95, 95, 95],
      [43, 66, 78, 85, 89, 92, 93, 94, 94, 94, 94, 94, 94, 94, 94],
      [40, 62, 74, 81, 86, 89, 92, 93, 94, 94, 94, 94, 94, 94, 94],
      [37, 58, 69, 77, 83, 87, 89, 91, 92, 93, 93, 93, 93, 93, 93],
      [35, 55, 66, 73, 79, 83, 86, 89, 90, 91, 92, 92, 92, 92, 92],
      [34, 52, 62, 70, 76, 80, 83, 86, 88, 89, 90, 90, 91, 91, 91],
      [32, 49, 59, 66, 72, 76, 80, 83, 85, 86, 87, 87, 88, 88, 89],
      [30, 46, 55, 63, 68, 73, 77, 80, 82, 83, 84, 84, 85, 86, 87],
      [29, 43, 52, 59, 65, 70, 73, 76, 79, 80, 81, 82, 82, 83, 84],
      [28, 41, 50, 57, 62, 67, 70, 73, 76, 77, 78, 79, 80, 80, 81],
      [27, 39, 47, 54, 60, 64, 68, 71, 73, 75, 76, 77, 78, 78, 79],
      [26, 38, 45, 52, 57, 62, 66, 69, 71, 73, 74, 75, 76, 76, 76],
      [25, 36, 43, 49, 55, 59, 64, 67, 69, 71, 72, 73, 74, 74, 74],
      [25, 35, 42, 47, 53, 57, 61, 65, 67, 69, 70, 71, 72, 72, 72],
      [24, 34, 40, 45, 50, 55, 59, 62, 65, 66, 68, 68, 69, 70, 70],
    ],
    5500: [
      [95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [74, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [66, 88, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [57, 81, 91, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [52, 76, 87, 92, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [47, 71, 83, 89, 92, 94, 94, 95, 95, 95, 95, 95, 95, 95, 95],
      [44, 67, 79, 86, 90, 92, 93, 94, 94, 95, 95, 95, 95, 95, 95],
      [41, 62, 74, 82, 87, 90, 92, 93, 94, 94, 94, 94, 94, 94, 94],
      [39, 59, 70, 78, 84, 88, 90, 92, 93, 93, 94, 94, 94, 94, 94],
      [37, 56, 67, 75, 80, 85, 88, 90, 91, 92, 93, 93, 94, 94, 94],
      [35, 53, 64, 71, 77, 82, 85, 88, 90, 91, 91, 92, 92, 93, 93],
      [33, 51, 60, 67, 73, 78, 82, 85, 87, 89, 90, 90, 91, 91, 91],
      [32, 48, 57, 64, 70, 75, 79, 82, 84, 86, 87, 88, 88, 89, 89],
      [31, 46, 54, 61, 67, 72, 76, 79, 81, 83, 85, 86, 86, 86, 87],
      [30, 44, 52, 59, 64, 69, 73, 76, 78, 80, 82, 83, 84, 84, 85],
      [29, 42, 50, 57, 62, 67, 71, 74, 76, 78, 80, 81, 82, 82, 82],
      [28, 41, 48, 54, 60, 64, 68, 72, 74, 76, 78, 79, 80, 80, 80],
      [27, 39, 47, 52, 57, 62, 66, 70, 72, 74, 76, 77, 78, 78, 78],
      [26, 38, 45, 50, 56, 60, 64, 68, 70, 72, 74, 75, 76, 76, 76],
      [26, 37, 43, 48, 54, 59, 63, 66, 69, 71, 72, 72, 73, 74, 75],
    ],
  },
  OUT_DURING_THE_DAY: {
    1500: [
      [55, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [40, 81, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [36, 70, 85, 91, 93, 93, 93, 93, 94, 94, 94, 94, 94, 94, 94],
      [29, 59, 74, 82, 86, 87, 88, 88, 88, 88, 88, 88, 88, 88, 88],
      [25, 52, 66, 74, 79, 81, 82, 82, 82, 83, 83, 83, 83, 83, 83],
      [22, 45, 59, 67, 72, 74, 75, 76, 76, 76, 76, 76, 76, 76, 76],
      [19, 40, 52, 60, 65, 67, 68, 69, 69, 70, 70, 70, 70, 70, 70],
      [17, 36, 47, 54, 59, 61, 62, 63, 63, 63, 63, 64, 64, 64, 64],
      [15, 33, 43, 49, 53, 56, 57, 57, 58, 58, 58, 58, 58, 58, 58],
      [14, 30, 39, 45, 49, 51, 52, 52, 52, 52, 52, 52, 52, 52, 52],
      [13, 27, 36, 42, 45, 47, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [12, 25, 33, 39, 42, 43, 43, 43, 43, 43, 43, 43, 43, 43, 43],
      [11, 23, 31, 36, 39, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
      [11, 22, 29, 34, 37, 37, 37, 37, 37, 37, 37, 37, 37, 37, 37],
      [10, 20, 27, 32, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
      [10, 19, 25, 30, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
      [10, 18, 24, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      [10, 17, 23, 27, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
      [10, 17, 22, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27],
      [10, 16, 21, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25],
    ],
    2000: [
      [58, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [43, 83, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [38, 71, 85, 91, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [31, 61, 76, 84, 88, 90, 91, 92, 92, 92, 92, 92, 92, 92, 92],
      [27, 54, 68, 77, 83, 86, 88, 88, 89, 89, 89, 89, 89, 89, 89],
      [23, 47, 61, 71, 77, 81, 83, 84, 84, 84, 84, 85, 85, 85, 85],
      [21, 42, 55, 64, 71, 75, 77, 78, 78, 78, 79, 79, 79, 79, 79],
      [19, 38, 50, 59, 65, 69, 71, 72, 72, 73, 73, 73, 73, 73, 73],
      [17, 35, 46, 54, 60, 64, 66, 67, 67, 67, 68, 68, 68, 68, 68],
      [16, 32, 42, 49, 55, 59, 61, 62, 62, 63, 63, 63, 63, 63, 63],
      [15, 29, 39, 46, 51, 54, 57, 58, 58, 59, 59, 59, 59, 59, 59],
      [14, 27, 36, 42, 47, 51, 53, 54, 55, 55, 55, 55, 55, 55, 55],
      [13, 25, 33, 39, 44, 48, 50, 51, 51, 51, 51, 51, 51, 51, 51],
      [12, 24, 31, 37, 42, 45, 47, 47, 47, 47, 47, 47, 47, 47, 47],
      [11, 22, 29, 35, 39, 42, 44, 44, 44, 44, 44, 44, 44, 44, 44],
      [11, 21, 27, 33, 37, 40, 41, 41, 41, 41, 41, 41, 41, 41, 41],
      [10, 20, 26, 31, 35, 38, 39, 39, 39, 39, 39, 39, 39, 39, 39],
      [10, 19, 25, 30, 34, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36],
      [10, 18, 23, 28, 32, 34, 34, 34, 34, 34, 34, 34, 34, 34, 34],
      [10, 17, 22, 27, 30, 33, 33, 33, 33, 33, 33, 33, 33, 33, 33],
    ],
    2500: [
      [61, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [45, 83, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [40, 71, 85, 91, 94, 94, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [33, 62, 77, 85, 90, 92, 93, 93, 93, 93, 93, 93, 93, 93, 93],
      [29, 55, 70, 79, 85, 89, 90, 91, 91, 92, 92, 92, 92, 92, 92],
      [25, 49, 63, 73, 80, 84, 87, 88, 88, 89, 89, 89, 89, 89, 89],
      [22, 44, 57, 67, 74, 79, 82, 84, 84, 85, 85, 86, 86, 86, 86],
      [20, 40, 52, 61, 69, 74, 77, 79, 80, 80, 81, 81, 81, 81, 81],
      [19, 36, 48, 56, 64, 69, 72, 74, 75, 76, 76, 76, 77, 77, 77],
      [17, 33, 43, 52, 59, 64, 67, 69, 70, 71, 71, 71, 72, 72, 72],
      [16, 30, 40, 48, 55, 60, 63, 65, 66, 66, 67, 67, 67, 67, 67],
      [15, 28, 37, 45, 51, 56, 59, 61, 62, 63, 63, 63, 63, 63, 63],
      [14, 26, 35, 42, 48, 52, 55, 57, 58, 59, 60, 60, 60, 60, 60],
      [13, 25, 33, 39, 45, 49, 52, 54, 55, 56, 57, 57, 57, 57, 57],
      [13, 23, 31, 37, 43, 47, 49, 51, 52, 53, 54, 54, 54, 54, 54],
      [12, 22, 29, 35, 40, 44, 47, 49, 50, 50, 50, 50, 50, 50, 50],
      [11, 21, 28, 33, 38, 42, 45, 47, 47, 47, 47, 47, 47, 47, 47],
      [11, 20, 26, 32, 36, 40, 43, 45, 45, 45, 45, 45, 45, 45, 45],
      [10, 19, 25, 30, 35, 38, 41, 42, 42, 42, 42, 42, 42, 42, 42],
      [10, 18, 24, 29, 33, 37, 39, 40, 40, 40, 40, 40, 40, 40, 40],
    ],
    3000: [
      [64, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [47, 86, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [42, 74, 87, 92, 94, 94, 94, 95, 95, 95, 95, 95, 95, 95, 95],
      [35, 64, 78, 86, 90, 92, 93, 94, 94, 94, 94, 94, 94, 94, 94],
      [30, 57, 71, 81, 86, 90, 92, 92, 92, 93, 93, 93, 93, 93, 93],
      [27, 51, 65, 75, 82, 86, 89, 90, 91, 91, 91, 91, 92, 92, 92],
      [24, 46, 59, 69, 76, 81, 85, 87, 88, 88, 89, 89, 89, 89, 89],
      [22, 41, 54, 63, 71, 76, 80, 83, 84, 85, 85, 86, 86, 86, 86],
      [20, 38, 49, 58, 65, 71, 75, 78, 80, 81, 81, 82, 82, 82, 82],
      [18, 35, 45, 54, 61, 66, 71, 74, 75, 77, 77, 78, 78, 78, 78],
      [17, 32, 42, 50, 57, 62, 66, 69, 71, 73, 73, 74, 74, 74, 74],
      [16, 30, 39, 47, 53, 59, 63, 66, 68, 69, 70, 70, 70, 70, 70],
      [15, 28, 36, 44, 50, 55, 60, 62, 64, 65, 66, 66, 67, 67, 67],
      [14, 26, 34, 41, 47, 52, 56, 59, 61, 62, 63, 63, 63, 63, 63],
      [14, 24, 32, 38, 44, 50, 53, 56, 58, 59, 60, 60, 60, 60, 60],
      [13, 23, 30, 36, 42, 47, 51, 54, 55, 57, 57, 58, 58, 58, 58],
      [12, 22, 29, 35, 40, 45, 49, 51, 53, 54, 55, 55, 56, 56, 56],
      [12, 21, 27, 33, 38, 43, 47, 49, 51, 52, 53, 53, 53, 53, 53],
      [11, 20, 26, 31, 37, 41, 45, 47, 49, 50, 50, 50, 50, 50, 50],
      [11, 19, 25, 30, 35, 39, 43, 45, 47, 47, 47, 47, 47, 47, 47],
    ],
    3500: [
      [65, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [49, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [44, 75, 88, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [36, 65, 79, 87, 91, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [31, 58, 72, 81, 87, 90, 92, 93, 93, 93, 93, 93, 93, 93, 93],
      [28, 52, 66, 75, 82, 87, 90, 91, 92, 92, 92, 92, 92, 92, 93],
      [25, 47, 60, 69, 77, 83, 86, 89, 90, 91, 91, 91, 91, 91, 91],
      [23, 42, 54, 64, 72, 78, 82, 85, 87, 88, 89, 89, 89, 89, 90],
      [21, 38, 50, 59, 67, 73, 78, 81, 84, 85, 86, 86, 87, 87, 87],
      [19, 35, 46, 55, 62, 69, 74, 77, 80, 81, 82, 83, 83, 83, 84],
      [18, 33, 43, 51, 58, 64, 69, 73, 76, 77, 78, 79, 79, 79, 80],
      [17, 31, 40, 48, 55, 61, 66, 69, 72, 73, 74, 75, 75, 75, 76],
      [16, 29, 37, 45, 51, 57, 62, 66, 68, 70, 71, 71, 72, 72, 72],
      [15, 27, 35, 42, 48, 54, 59, 63, 65, 66, 67, 68, 68, 68, 69],
      [15, 26, 33, 40, 46, 51, 56, 60, 62, 63, 64, 65, 65, 66, 66],
      [14, 24, 31, 37, 43, 49, 53, 57, 59, 60, 62, 62, 63, 63, 63],
      [13, 23, 30, 36, 41, 47, 51, 54, 57, 58, 59, 60, 60, 61, 61],
      [12, 22, 28, 34, 40, 45, 49, 52, 55, 56, 57, 58, 58, 59, 59],
      [12, 21, 27, 32, 38, 43, 47, 50, 53, 54, 56, 56, 57, 57, 57],
      [11, 20, 25, 31, 36, 41, 45, 48, 51, 53, 54, 54, 54, 54, 54],
    ],
    4000: [
      [66, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [49, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [45, 76, 89, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [37, 66, 80, 87, 91, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [32, 59, 73, 82, 87, 91, 92, 93, 93, 93, 93, 93, 93, 93, 93],
      [28, 53, 67, 76, 83, 87, 90, 92, 92, 92, 93, 93, 93, 93, 93],
      [26, 48, 61, 70, 78, 83, 87, 89, 91, 91, 92, 92, 92, 92, 92],
      [24, 43, 55, 65, 73, 79, 83, 86, 88, 90, 91, 91, 91, 91, 91],
      [22, 39, 50, 59, 67, 74, 79, 83, 85, 87, 88, 89, 90, 90, 90],
      [20, 36, 46, 55, 63, 70, 75, 79, 82, 84, 85, 86, 87, 87, 87],
      [19, 34, 44, 52, 59, 66, 71, 75, 78, 81, 82, 83, 83, 84, 84],
      [18, 32, 41, 49, 56, 62, 67, 72, 75, 77, 78, 80, 80, 80, 81],
      [17, 30, 39, 46, 53, 59, 64, 68, 70, 73, 75, 76, 76, 77, 77],
      [16, 28, 36, 43, 50, 55, 60, 64, 67, 69, 71, 72, 73, 74, 74],
      [15, 26, 33, 40, 47, 52, 57, 61, 64, 66, 68, 69, 70, 71, 71],
      [14, 25, 32, 38, 44, 50, 55, 58, 61, 64, 65, 67, 67, 68, 68],
      [14, 23, 30, 36, 42, 48, 52, 56, 59, 62, 63, 64, 65, 65, 66],
      [13, 22, 29, 34, 40, 45, 50, 54, 57, 60, 61, 62, 63, 63, 64],
      [13, 21, 27, 33, 38, 43, 48, 52, 55, 58, 59, 60, 61, 61, 62],
      [12, 20, 26, 31, 36, 41, 46, 50, 53, 56, 57, 58, 59, 60, 60],
    ],
    4500: [
      [66, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [49, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [45, 76, 89, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [37, 66, 80, 87, 91, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [32, 59, 73, 82, 88, 91, 92, 93, 93, 93, 94, 94, 94, 94, 94],
      [28, 53, 67, 76, 83, 88, 90, 92, 93, 93, 93, 93, 93, 93, 93],
      [26, 48, 61, 70, 78, 84, 87, 90, 91, 92, 92, 92, 92, 92, 92],
      [24, 43, 55, 65, 73, 79, 83, 86, 89, 90, 91, 91, 91, 91, 91],
      [22, 39, 51, 60, 68, 74, 79, 83, 86, 88, 90, 90, 90, 90, 90],
      [20, 36, 47, 56, 63, 70, 75, 79, 83, 86, 87, 88, 89, 89, 89],
      [19, 34, 44, 52, 59, 66, 71, 76, 80, 83, 85, 86, 86, 87, 87],
      [18, 32, 41, 49, 56, 62, 68, 73, 77, 79, 81, 82, 84, 84, 85],
      [17, 30, 39, 46, 53, 59, 64, 69, 73, 76, 78, 79, 80, 81, 81],
      [16, 28, 36, 43, 50, 56, 61, 66, 70, 73, 74, 76, 77, 78, 78],
      [15, 26, 34, 41, 47, 53, 58, 63, 67, 70, 71, 73, 74, 75, 76],
      [14, 25, 32, 39, 45, 51, 56, 60, 64, 67, 69, 70, 71, 72, 73],
      [14, 24, 31, 37, 43, 49, 53, 58, 61, 64, 67, 68, 69, 70, 70],
      [13, 23, 29, 35, 41, 46, 51, 56, 59, 62, 65, 66, 67, 68, 68],
      [13, 22, 28, 33, 39, 44, 49, 53, 57, 60, 63, 64, 65, 66, 66],
      [12, 21, 27, 32, 37, 42, 46, 51, 56, 59, 61, 63, 64, 65, 65],
    ],
    5000: [
      [66, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [49, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [45, 76, 89, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [37, 66, 80, 87, 91, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [32, 59, 73, 82, 88, 91, 93, 93, 93, 94, 94, 94, 94, 94, 94],
      [28, 53, 67, 76, 83, 88, 91, 92, 93, 93, 93, 93, 93, 93, 93],
      [26, 48, 61, 71, 78, 84, 88, 90, 91, 92, 92, 93, 93, 93, 93],
      [24, 43, 55, 65, 73, 79, 84, 87, 89, 91, 92, 92, 92, 92, 92],
      [22, 39, 51, 60, 68, 75, 80, 84, 87, 89, 90, 91, 91, 92, 92],
      [20, 36, 47, 56, 64, 71, 76, 81, 84, 86, 88, 89, 90, 90, 91],
      [19, 35, 44, 53, 60, 66, 72, 77, 81, 83, 85, 87, 88, 88, 88],
      [18, 33, 42, 49, 56, 62, 68, 73, 77, 80, 82, 84, 85, 86, 86],
      [17, 31, 40, 46, 53, 59, 64, 69, 73, 76, 79, 81, 83, 83, 83],
      [16, 29, 37, 43, 50, 56, 61, 66, 70, 73, 76, 78, 80, 80, 81],
      [15, 27, 35, 41, 47, 53, 58, 63, 67, 70, 73, 75, 77, 77, 78],
      [14, 26, 33, 39, 45, 51, 56, 60, 64, 68, 71, 73, 74, 75, 76],
      [14, 24, 31, 37, 43, 49, 53, 58, 61, 66, 69, 71, 72, 73, 74],
      [13, 23, 30, 36, 41, 46, 51, 56, 60, 64, 66, 68, 70, 72, 73],
      [13, 22, 28, 34, 39, 44, 49, 54, 58, 62, 65, 67, 68, 70, 71],
      [12, 21, 27, 32, 37, 42, 48, 53, 58, 61, 63, 65, 66, 68, 69],
    ],
    5500: [
      [66, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [49, 91, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [45, 76, 89, 93, 94, 95, 95, 95, 95, 95, 95, 95, 95, 95, 95],
      [37, 66, 80, 87, 91, 93, 94, 94, 94, 94, 94, 94, 94, 94, 94],
      [32, 59, 73, 82, 88, 91, 93, 93, 93, 94, 94, 94, 94, 94, 94],
      [28, 53, 67, 76, 83, 88, 91, 92, 93, 93, 93, 93, 93, 93, 93],
      [26, 48, 61, 71, 78, 84, 88, 90, 91, 92, 92, 93, 93, 93, 93],
      [24, 43, 55, 65, 73, 80, 84, 87, 89, 91, 92, 92, 92, 92, 92],
      [22, 39, 51, 60, 68, 75, 80, 84, 87, 89, 90, 91, 91, 92, 92],
      [20, 36, 47, 56, 64, 71, 76, 81, 84, 86, 88, 89, 90, 90, 91],
      [19, 35, 45, 53, 60, 66, 72, 77, 81, 84, 86, 87, 88, 88, 90],
      [18, 34, 43, 50, 56, 62, 68, 74, 78, 81, 84, 85, 86, 87, 88],
      [17, 32, 41, 47, 53, 59, 65, 70, 75, 78, 81, 83, 84, 85, 85],
      [16, 31, 38, 44, 50, 56, 62, 67, 72, 76, 79, 81, 82, 82, 83],
      [15, 29, 36, 42, 48, 54, 59, 64, 69, 73, 76, 78, 80, 80, 81],
      [15, 27, 34, 40, 46, 52, 57, 62, 66, 70, 73, 76, 77, 78, 79],
      [14, 25, 32, 38, 44, 49, 54, 59, 63, 67, 70, 73, 76, 77, 78],
      [13, 24, 30, 36, 42, 47, 52, 57, 61, 64, 68, 71, 74, 75, 76],
      [13, 22, 29, 34, 39, 45, 49, 54, 58, 62, 65, 69, 71, 73, 74],
      [12, 21, 27, 32, 37, 43, 48, 53, 58, 61, 63, 65, 68, 70, 72],
    ],
  },
};
